import { Card, CardActionArea, Divider, Grid, Typography } from "@mui/material"
import './Expense.css';
import _ from "lodash";
import { useMemo } from "react";
import PieChartExpenses from "./Chart/PieChart";
import LineChartExpenses from "./Chart/LineChart";

//icon
import { FaFlagCheckered } from "react-icons/fa";
import { FaMoneyBill1Wave } from "react-icons/fa6";
import { useInitCompareExpenses } from "./init/useExpenses";

const CompareExpenses = ({ data, arrYear, setIsCheckYear, setNYear, setArrMonth }) => {

    const arrSelectYear = useMemo(() => {
        let arrYearMap = arrYear.map(item => ({ field: "Y" + (parseInt(item) + 543), name: parseInt(item) + 543 }));
        let arrYearOrder = _.orderBy(arrYearMap, ['name'], ['asc']);

        return arrYearOrder;
    }, [arrYear]);

    const HandleClickBoxYear = (nYear) => {
        nYear = nYear - 543;
        let lstMonth = [
            { label: "มกราคม", value: "1", disabled: false },
            { label: "กุมภาพันธ์", value: "2", disabled: false },
            { label: "มีนาคม", value: "3", disabled: false },
            { label: "เมษายน", value: "4", disabled: false },
            { label: "พฤภาคม", value: "5", disabled: false },
            { label: "มิถุนายน", value: "6", disabled: false },
            { label: "กรกฎาคม", value: "7", disabled: false },
            { label: "สิงหาคม", value: "8", disabled: false },
            { label: "กันยายน", value: "9", disabled: false },
            { label: "ตุลาคม", value: "10", disabled: false },
            { label: "พฤศจิกายน", value: "11", disabled: false },
            { label: "ธันวาคม", value: "12", disabled: false },
        ]
        setIsCheckYear(true);
        setNYear(nYear);
        setArrMonth(lstMonth.filter(f => !f.disabled).map(m => m.value));
    }



    const { arrInitExpensesLineChart, arrInitExpensesBox, arrInitPlanExpensesLineChart, arrSection, arrSection5 } = useInitCompareExpenses({ data, arrYear });

    return (
        <Grid container spacing={2} marginTop={2}>
            <Grid item md={1} xs={12}>
            </Grid>
            <Grid item md={10} xs={12} className="flex-center">
                <div className="box-topic-expense">
                    เปรียบเทียบข้อมูลรายจ่ายเงินกองทุนจัดการซากดึกดำบรรพ์
                </div>
            </Grid>
            <Grid item md={9} xs={12}>
                <LineChartExpenses
                    keyId={"result"}
                    title={"รายจ่ายรวม"}
                    data={[...arrInitExpensesLineChart]}
                    xAxis={"sMonth"}
                    lstRenderLine={arrSelectYear}
                />
            </Grid>
            <Grid item md={3} xs={12}>
                <Grid container spacing={2} sx={{ color: "#FFFFFF", maxHeight: "600px", overflow: "hidden", overflowY: "scroll" }}>
                    <div className="ag-format-container">
                        <div className="ag-income_box">
                            {arrInitExpensesBox.map((m, i) => {
                                return (
                                    <Card
                                        key={m.nYear}
                                        className="ag-income_item"
                                        variant="outlined"
                                        sx={{
                                            padding: '0px !important'
                                        }}
                                    >
                                        <CardActionArea
                                            className="ag-income-item_link"
                                            onClick={() => HandleClickBoxYear(m.nYear)}
                                            sx={{
                                                padding: '12px !important'
                                            }}
                                        >
                                            <div className="ag-income-item_bg"></div>
                                            <Grid container spacing={1} justifyContent={"flex-start"} alignItems={"center"}>
                                                <Grid item xs={12} >
                                                    <Grid container spacing={1} justifyContent={"flex-end"} alignItems={"center"}>
                                                        <Grid item xs={12} md={11.5} style={{ display: 'flex', alignItems: "center" }}>
                                                            <FaFlagCheckered className='card-icon' />
                                                            <span className='card-value'>{m.sBudget}</span>
                                                        </Grid>
                                                        <Grid item xs={12} ><Typography className='card-title'>รายจ่ายตามแผนงาน</Typography></Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12} >
                                                    <Divider className='card-divider' />
                                                </Grid>
                                                <Grid item xs={12} >
                                                    <Grid container spacing={1} justifyContent={"flex-end"} alignItems={"center"}>

                                                        <Grid item xs={12} md={11.5} style={{ display: 'flex', alignItems: "center" }}>
                                                            <FaMoneyBill1Wave className='card-icon' />
                                                            <span className='card-value'>{m.sResult}</span>
                                                        </Grid>

                                                        <Grid item xs={12} ><Typography className='card-title'>รายจ่ายรวม</Typography></Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Typography className='text-year'>
                                                {m.nYear}
                                            </Typography>
                                            <Typography className='text-percent-dashboard'>
                                                {m.sPercent}
                                            </Typography>
                                        </CardActionArea>
                                    </Card>
                                )
                            })}
                        </div>
                    </div>

                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    {arrSection.map((m, i) => {
                        return (
                            <Grid key={m.nYear} item xs={12} md={6}>
                                <PieChartExpenses
                                    sTypeChart={"budget"}
                                    year={m.nYear}
                                    keyId={m.nYear}
                                    title={m.sTitle}
                                    data={[...m.lstData]}
                                />
                            </Grid>
                        )
                    })}
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    {arrSection5.map((m, i) => {
                        return (
                            <Grid key={m.nYear} item xs={12} md={6}>
                                <PieChartExpenses
                                    sTypeChart={"section"}
                                    year={m.nYear}
                                    keyId={m.nYear}
                                    title={m.sTitle}
                                    data={[...m.lstData]}
                                />
                            </Grid>
                        )
                    })}
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <LineChartExpenses
                    keyId={"plan"}
                    title={"รายจ่ายตามแผน"}
                    data={[...arrInitPlanExpensesLineChart]}
                    xAxis={"sMonth"}
                    lstRenderLine={arrSelectYear}
                />
            </Grid>
        </Grid>
    )
}

export default CompareExpenses;
